import { PatientPreferencesResponse } from "../../../../../../../services/api-client/contact-api";

export const getCustomizedPhoneCount = (patientPreferences: PatientPreferencesResponse) => {
  let count = 0;
  patientPreferences.pcAppointmentConfirmations !== false ? count++ : null;

  return count;
};